export const FETCH_PROFILES = 'FETCH_PROFILES'
export const FETCH_GROUPS = 'FETCH_GROUPS'

export const LOAD_PROFILES = 'LOAD_PROFILES'
export const LOAD_GROUPS = 'LOAD_GROUPS'

/**
  * fetchProfiles
  * @desc fetch Profiles action generator
  * @param {string} ID accountID
  * @param {Object} options Query options
  * @return {action} FetchProfileAction
*/
export function fetchProfiles (ID, options) {
  const query = { accountId: ID }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  return { type: FETCH_PROFILES, query }
}

/**
  * fetchGroups
  * @desc fetch Groups Action Generator
  * @param {string} ID account ID
  * @param {Object} options
  * @return {action} FetchGroupsAction
*/
export function fetchGroups (ID, options) {
  const query = { accountId: ID }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  return { type: FETCH_GROUPS, query }
}

/**
  * loadProfiles
  * @desc Load Profiles Action Generator
  * @param {Object} data
  * @return {action} loadProfilesAction
*/
export function loadProfiles (data) {
  return { type: LOAD_PROFILES, data }
}

/**
  * loadGroups
  * @desc Load Groups Action Generator
  * @param {Object} data
  * @return {action} loadGroupsAction
*/
export function loadGroups (data) {
  return { type: LOAD_GROUPS, data }
}
